interface IloyaltyHelpFaqData {
  title: string;
  content: string;
}

export const loyaltyHelpFaqData: IloyaltyHelpFaqData[] = [
  {
    title: "loyalty.faq1.title",
    content: "loyalty.faq1.text",
  },
  {
    title: "loyalty.faq2.title",
    content: "loyalty.faq2.text",
  },
  { title: "loyalty.faq3.title", content: "loyalty.faq3.text" },
  {
    title: "loyalty.faq4.title",
    content: "loyalty.faq4.text",
  },
  {
    title: "loyalty.faq5.title",
    content: "loyalty.faq5.text",
  },
  {
    title: "loyalty.faq6.title",
    content: "loyalty.faq6.text",
  },
  {
    title: "loyalty.faq7.title",
    content: "loyalty.faq7.text",
  },
  { title: "loyalty.faq8.title", content: "loyalty.faq8.text" },
];
